import axios from "axios";

const httpClient = axios.create({
  baseURL: "https://admin.dreamlinks.golf/", // staging server
 //baseURL: "http://172.16.100.73:8037/",
  // baseURL: "http://3.12.59.116:8037/",
  // baseURL: "http://192.168.6.177:9719/api/v1/", // local server
  // baseURL: "https://95f2d39c527d.ngrok-free.app/",
});

// Request interceptor
httpClient.interceptors.request.use(
  (request) => {
    // Do something with the request config (e.g., add headers, authentication token)
    // For example:
    // request.headers['Authorization'] = 'Bearer sfsdfsdf';
    let token = window.localStorage.getItem("DreamToken");
    if (token) {
      token = JSON.parse(token);
    }

    request.headers["Authorization"] = `Bearer ${token}`;
    // console.log("token => ", `Bearer ${token}`);
    // console.log("request interceptors", request);

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
httpClient.interceptors.response.use(
  (response) => {
    // Do something with the response data
    return response;
  },
  (error) => {
    // console.log("Response Intercetor err", error);
    if (error.response && error.response.status === 403) {
      const token = localStorage.getItem("DreamToken");
      if (token) {
        localStorage.removeItem("DreamToken");
        window.location.href = "/admin-panel/auth/login";
      }
    }
    // Do something with the response error (e.g., error handling, logging)
    return Promise.reject(error);
  },
);

export default httpClient;
